<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-toolbox', fontSet: 'fad'}"
	[headerText]="(T.REGISTER_DEVICE_DIALOG_TITLE | translate) + ' ' + data?.deviceIdToBeMapped"
	[matDialogData]="data"
	[rect]="rect"
>
	<div dialogContent class="deviceTypeSelectionWrapper h-100">
		@if (!userAuthenticated) {
			<div class="notAuthenticatedCon">
				<h1 class="notAuthenticatedHeader">{{ T.REGISTER_DEVICE_DIALOG_NOT_AUTHENTICATED_HEADER | translate }}</h1>
				<div class="notAuthenticatedDescription">{{ T.REGISTER_DEVICE_DIALOG_NOT_AUTHENTICATED_DESCRIPTION | translate }}</div>
				<div class="openLoginDialog">
					<sim-button
						class="manualRegistrationBtn"
						[icon]="{fontSet: 'fad', fontIcon: 'fa-lock-open'}"
						(onClick)="openLoginDialog()"
						[label]="T.REGISTER_DEVICE_OPEN_LOGIN_DIALOG"
					/>
				</div>
			</div>
		}

		@if (userAuthenticated) {
			<div class="wrapperHeader secondary">
				<!--TODO: Uncomment back button when configuration of device capability is implemented-->
				<!--			<button [class.showing]="selectedAutoLoginType !== null" (click)="configurationStepBack()" mat-icon-button color="accent" class="backToDeviceSelectionBtn">-->
				<!--				<mat-icon fontSet="fad" fontIcon="fa-arrow-left" inline="true"></mat-icon>-->
				<!--			</button>-->
				@if (configureAutoLoginOrDeviceCapability === null) {
					{{ T.REGISTER_DEVICE_DESCRIPTION_NO_SELECTION | translate }}
				} @else if (selectedAutoLoginType === null) {
					{{ T.REGISTER_DEVICE_DESCRIPTION_AUTO_LOGIN_SELECTED | translate }}
				} @else {
					{{ T.REGISTER_DEVICE_DESCRIPTION_DEVICE_CAPABILITY_SELECTED | translate }}
					{{ VM_AutoLoginCapabilityType[selectedAutoLoginType] | translate }}
				}
			</div>
			<!--			TODO: ONLY AUTOLOGIN CAPABILITIES CAN BE CONFIGURED AT THE MOMENT-->
			<!--			<div class="autoLoginOrDeviceCapabilitySelection" *ngIf="selectedAutoLoginType === null">-->
			<!--				<div-->
			<!--					class="deviceType"-->
			<!--					mat-ripple-->
			<!--					(click)="setAutoLoginCapability(VM_DeviceCapabilityType.AUTO_LOGIN)"-->
			<!--					[class.active]="configureAutoLoginOrDeviceCapability() === 'AUTO_LOGIN'"-->
			<!--				>-->
			<!--					<div class="deviceTypeIcon">-->
			<!--						<i class="fa-2x fad fa-sign-in"></i>-->
			<!--					</div>-->
			<!--					<div class="deviceTypeLabel">-->
			<!--						<span>{{ T.REGISTER_DEVICE_SET_AUTOLOGIN_CAPABILITY | translate }}</span>-->
			<!--					</div>-->
			<!--				</div>-->
			<!--				<div-->
			<!--					class="deviceType"-->
			<!--					mat-ripple-->
			<!--					(click)="setAutoLoginCapability(VM_DeviceCapabilityType.DEVICE_CAPABILITY)"-->
			<!--					[class.active]="configureAutoLoginOrDeviceCapability() === 'DEVICE_CAPABILITY'"-->
			<!--				>-->
			<!--					<div class="deviceTypeIcon">-->
			<!--						<i class="fa-2x fad fa-phone-laptop"></i>-->
			<!--					</div>-->
			<!--					<div class="deviceTypeLabel">-->
			<!--						<span>{{ T.REGISTER_DEVICE_SET_DEVICE_CAPABILITY | translate }}</span>-->
			<!--					</div>-->
			<!--				</div>-->
			<!--			</div>-->
			@if (configureAutoLoginOrDeviceCapability() !== null) {
				<mat-divider />
			}
			@if (selectedAutoLoginType === null && configureAutoLoginOrDeviceCapability() === VM_DeviceCapabilityType.AUTO_LOGIN) {
				<div class="deviceTypeSelection">
					@for (deviceType of autoLoginTypes; track deviceType) {
						<div class="deviceType" (click)="selectDeviceType(deviceType.type)" mat-ripple>
							<div class="deviceTypeIcon">
								<i class="fa-2x {{ deviceType.icon.fontSet }} {{ deviceType.icon.fontIcon }}"></i>
							</div>
							<div class="deviceTypeLabel">
								<span>{{ T["AUTO_LOGIN_TYPE_" + VM_AutoLoginCapabilityType[deviceType.type]] | translate }}</span>
							</div>
						</div>
					}
				</div>
			}
			<!--
TODO: Implement Device Capability Selection
-->
			@if (selectedAutoLoginType === null && configureAutoLoginOrDeviceCapability() === VM_DeviceCapabilityType.DEVICE_CAPABILITY) {
				<div class="deviceTypeSelection">NOT YET IMPLEMENTED</div>
			}
			@if (selectedAutoLoginType !== null) {
				<div class="deviceTypeRegistrationWrapper">
					@switch (selectedAutoLoginType) {
						@case (VM_AutoLoginCapabilityType.EXAM_DEVICE) {
							<sim-setup-auto-login
								[deviceId]="data?.deviceIdToBeMapped"
								[selectableDeviceTypes]="selectableExamDeviceTypes"
								[getAutoLoginType]="getExamAutologinType"
								(deviceRegistered)="close({action: 'ok'})"
							/>
						}
						@case (VM_AutoLoginCapabilityType.DISPLAY_DEVICE) {
							<sim-setup-auto-login
								[deviceId]="data?.deviceIdToBeMapped"
								[selectableDeviceTypes]="selectableDisplayTypes"
								[getAutoLoginType]="getDisplayAutologinType"
								(deviceRegistered)="close({action: 'ok'})"
							/>
						}
					}
				</div>
			}
		}
	</div>

	<ng-container actions>
		<div class="actionButtons">
			<button mat-button color="accent" (click)="openQrCodeDialog()">
				{{ T.REGISTER_DEVICE_SHOW_QR_CODE_FOR_REGISTRATION | translate }}
			</button>

			<sim-button (onClick)="close()" [icon]="{fontSet: 'fad', fontIcon: 'fa-times'}" [label]="T.BUTTON_CANCEL" color="warn" />
		</div>
	</ng-container>
</sim-basic-material-dialog>
